import { render, staticRenderFns } from "./Addcertification.vue?vue&type=template&id=dee61920&scoped=true"
import script from "./Addcertification.vue?vue&type=script&lang=js"
export * from "./Addcertification.vue?vue&type=script&lang=js"
import style0 from "./Addcertification.vue?vue&type=style&index=0&id=dee61920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee61920",
  null
  
)

export default component.exports